import * as React from 'react';
import { Alert } from 'react-bootstrap';

export const WebsiteAccountVoucherCodesPage = (): React.JSX.Element => (
  <Alert variant="info">Voucher code self-service is being migrated. Please use the admin voucher page for now.</Alert>
);
